<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Transaction Activity Type</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Transaction Activity Type</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <el-dropdown split-button :trigger="'click'"
                           @command="handleSelectedRows"
                           type="primary" v-if="this.selected_row.length" class="mr-1">
                {{ this.selected_row.length }} {{ 'item' | pluralize(this.selected_row.length) }} selected
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="delete">Delete Selected Items</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <button class="btn btn-info" type="button" @click="showFilter = !showFilter">
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>

            <div class="card-tools">
              <router-link :to="{ name: 'EWTrxActivityTypeAdd'}" class="btn btn-success" v-if="actionCreate">
                <i class="fas fa-plus"></i> New
              </router-link>
              <button class="btn btn-info" @click="exportFile()">
                <i class="fas fa-download"></i> Export
              </button>

            </div>
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="status">Activity Type</label>
                    <div class="col-md-9">
                      <select class="form-control" style="width: 100%;" id="trx_activity_type_id"
                              name="trx_activity_type_id"
                              v-model="filter.trx_activity_type_id">
                        <option v-for="(val, index) in activityTypes" :value="val.value">{{ val.label }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="per_trx_min_amount">Per Trx Min Amount</label>
                    <div class="col-md-9">
                      <input type="text" id="per_trx_min_amount" class="form-control"
                             v-model="filter.per_trx_min_amount"
                             placeholder="Per Trx Min Amount">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="per_trx_max_amount">Per Trx Max Amount</label>
                    <div class="col-md-9">
                      <input type="text" id="per_trx_max_amount" class="form-control"
                             v-model="filter.per_trx_max_amount"
                             placeholder="Per Trx Max Amount">
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="slug">Slug</label>
                    <div class="col-md-9">
                      <input type="text" id="slug" class="form-control" v-model="filter.slug" placeholder="Slug">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="status">Status</label>
                    <div class="col-md-9">
                      <select class="form-control" style="width: 100%;" id="status" name="status"
                              v-model="filter.status">
                        <option value="active">Active</option>
                        <option value="rejected">Inactive</option>
                      </select>
                    </div>

                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9">
                      <button type="submit" class="btn btn-common m-2px"><i class="fas fa-search"></i> Search</button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()"><i class="fas fa-undo"></i>
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body table-responsive-md p-0">
            <div class="overlay text-center" v-if="is_loading">
              <img :src="getImage('logo.svg')" class="loader-img" alt="loader">
            </div>
            <table class="table">
              <thead>
              <tr>

                <th style="width: 10px">
                  <input type="checkbox" v-model="is_selected_all" @click="selectedRowAll()">
                </th>
                <th>ID
                  <sort-icons :_sort="'id'"/>
                </th>
                <th>Activity Type
                  <sort-icons :_sort="'activity_type'"/>
                </th>
                <th>Receiver Type
                  <sort-icons :_sort="'activity_type'"/>
                </th>
                <th>Per Trx Min Amount
                  <sort-icons :_sort="'per_trx_min_amount'"/>
                </th>
                <th>Per Trx Max Amount
                  <sort-icons :_sort="'per_trx_max_amount'"/>
                </th>

                <th>Status
                  <sort-icons :_sort="'status'"/>
                </th>
                <th class="text-right">Action</th>

              </tr>
              </thead>
              <tbody class="list">
              <tr v-for="(val, index) in list.data">

                <td>
                  <input type="checkbox" v-model="selected_row" :value="val.id">
                </td>
                <td>{{ val.id }}</td>
                <td>{{ val.activity_type }}</td>
                <td>{{
                    !_.isEmpty(val.activity_type_with_receiver_type_id) ?
                        val.activity_type_with_receiver_type_id.activity_type : 'NA'
                  }}
                </td>
                <td>{{ val.per_trx_min_amount }}</td>
                <td>{{ val.per_trx_max_amount }}</td>

                <td>{{ !_.isEmpty(val.status) ? val.status.charAt(0).toUpperCase() + val.status.slice(1) : 'NA' }}</td>
                <td class="text-right">
                  <button class="btn btn-info btn-sm m-2px" @click="showTrxActivityTypeLogs(val.id)">
                    <i class="fas fa-history"></i>
                  </button>
                  <router-link v-if="actionView == true" :to="{ name: 'EWTrxActivityTypeShow', params: { id: val.id }}"
                               class="btn btn-info btn-sm m-2px">
                    <i class="fas fa-eye"></i>
                  </router-link>
                  <router-link v-if="actionEdit == true && checkEditPermission(val)"
                               :to="{ name: 'EWTrxActivityTypeEdit', params: { id: val.id }}"
                               class="btn btn-info btn-sm m-2px">
                    <i class="fas fa-pencil-alt"></i>
                  </router-link>
                  <a v-if="actionDelete == true && checkDeletePermission(val)" class="btn btn-danger btn-sm m-2px"
                     href="javascript:void(0)" @click="deleteObject(val.id, index)"><i class="fas fa-trash"></i></a>
                </td>

              </tr>
              </tbody>
            </table>
            <div class="p-4" v-if="empty && is_loading == false">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>


          <div class="card-footer">
            <vue-pagination
                :pagination="list"
                v-if="list.total > list.per_page"
                @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
    <b-modal title="Transaction Activity Type Logs" id="trxActivityTypeLogs" hide-footer size="lg">
      <div class="table-responsive">
        <table class="table table-striped table-border">
          <thead class="bg-info">
          <tr>
            <th>SL</th>
            <th>Previous Data</th>
            <th>Current Data</th>
            <th>Changed By</th>
            <th>Date</th>
          </tr>
          </thead>
          <tbody v-if="!trxActivityTypeLogs.length">
          <tr>
            <td colspan="5" class="text-center">No Data Found</td>
          </tr>
          </tbody>
          <tbody>

          <tr v-for="(log,i) in trxActivityTypeLogs">
            <td>{{ i + 1 }}</td>
            <td>
              <pre>{{ JSON.parse(log.previous_data) }}</pre>
            </td>
            <td>
              <pre>{{ JSON.parse(log.current_data) }}</pre>
            </td>
            <td>{{ log.user }}</td>
            <td>{{ customFormatter(log.date, 'lll') }}</td>
          </tr>
          </tbody>

        </table>
        <div class="clearfix"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment/moment";
import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import {CommonAPI, PermissionChecker} from '@/services/api'
import {mapGetters, mapActions} from 'vuex'
import {Notification} from 'element-ui'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const fileDownload = require('js-file-download')


export default {
  name: 'EWTrxActivityType',
  metaInfo: {
    title: 'Trx Activity Type | Dotlines'
  },
  components: {
    DatePicker, VuePagination, SortIcons
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionCreate: false,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: '',
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
    activityTypes: [],
    trxActivityTypeLogs: [],
  }),
  mounted: function () {
    this.getActivityTypes()
    if (this.isMobile()) {
      //window.$(document).find('.push-menu-class').trigger('click');
      window.$("body").removeClass("sidebar-open")
      window.$("body").addClass("sidebar-closed sidebar-collapse")
    }
    this.api_url = '/ew_trx_activity_types'
    this.initialize()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
      this.reload()
    });
    this.$root.$on('bv::modal::hide', (bvEvent, trxActivityTypeLogs) => {
      console.log('Modal is about to be close', bvEvent, trxActivityTypeLogs)
      this.trxActivityTypeLogs = [];
    })
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    customFormatter(date, format = 'MMM Do YY, h:mm:ss a') {
      return moment(date).format(format);
    },
    async initialize() {
      this.is_loading = true
      // eslint-disable-next-line no-undef
      if (_.isEmpty(this.profile)) {
        // eslint-disable-next-line camelcase
        await CommonAPI.getProfile().then(profile_info => {
          // eslint-disable-next-line camelcase
          this.user_detail = profile_info
        })
      } else {
        this.user_detail = this.profile
      }

      await CommonAPI.getCustomPermission('/get-custom-permission-infos?path=api/ew_trx_activity_types').then(response => {
        // eslint-disable-next-line eqeqeq
        if (response.status == 200) {
          this.custom_permission_data = response.data
        }
      });

      // eslint-disable-next-line no-undef
      if (!_.isEmpty(this.custom_permission_data)) {
        this.actionCreate = await PermissionChecker.checkCreateButtonPermission(this.custom_permission_data.action_permission,
            this.custom_permission_data['create_id_condition'], this.user_detail, this.custom_permission_data.enableAdministratorPermissionByDefault)
      }

      await this.getList().then(response => {
        this.list = response.data
      }).catch(error => {
        this.empty = true
        if (error.response.status === 403) {
          this.has_permission = false
        }
      });
      this.is_loading = false
    },
    async getFilterData() {
      this.is_loading = true
      await this.getList().then(response => {
        this.list = response.data
      }).catch(error => {
        this.empty = true
        if (error.response.status === 403) {
          this.has_permission = false
        }
      })
      this.is_loading = false
    },
    reload: function () {
      this.getList().then(response => {
        this.list = response.data
      }).catch(error => {
        this.empty = true
        if (error.response.status === 403) {
          this.has_permission = false
        }
      })
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        /* let params = {page: this.list.current_page}
        params = {...this.filter, ...this.$route.query, ...params} */
        const params = {...this.filter, ...this.$route.query}
        axios.get(this.api_url, {
          params: params
        }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
          //console.log("error", error.response.data);
        }).finally(() => {
          //_this.is_loading = false;
        })
      })
    },
    checkEditPermission: function (data) {
      return this.checkRole()
      // eslint-disable-next-line no-undef
      /*if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(this.custom_permission_data.action_permission, this.custom_permission_data['edit_id_condition'],
            this.custom_permission_data['edit_refid_condition'], this.custom_permission_data['edit_custom_condition'], data, this.user_detail, this.custom_permission_data.enableAdministratorPermissionByDefault, this.custom_permission_data['operator_between_block_condition_rules'])
      } else {
        return false
      }*/
    },
    checkDeletePermission: function (data) {
      return this.checkRole()
      // eslint-disable-next-line no-undef
      /* if (!_.isEmpty(this.custom_permission_data)) {
         return PermissionChecker.checkDeleteButtonPermission(this.custom_permission_data.action_permission, this.custom_permission_data['delete_id_condition'],
             this.custom_permission_data['delete_refid_condition'], this.custom_permission_data['delete_custom_condition'], data, this.user_detail, this.custom_permission_data.enableAdministratorPermissionByDefault, this.custom_permission_data['operator_between_block_condition_rules'])
       } else {
         return false
       }*/
    },
    async checkRole() {
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then(profile_info => {
          this.user_detail = profile_info
        })
      } else {
        this.user_detail = this.profile
      }
      const allowedRoles = this.APP_TRX_CONFIG_ALLOWED_ROLES.split(',').map(role => parseInt(role, 10));
      let userRole = this.user_detail.roles[0].id;
      console.log("access:", allowedRoles.includes(userRole))
      return allowedRoles.includes(userRole);
    },

    async resetFilter() {
      this.list.current_page = 1
      this.filter = {}
      this.is_loading = true
      await this.getList().then(response => {
        this.list = response.data
      }).catch(error => {
        this.empty = true

        if (error.response.status === 403) {
          this.has_permission = false
        }
      })
      this.is_loading = false
    },
    deleteObject: function (id, index) {
      const _this = this
      let delete_api_url = '/ew_trx_activity_types/' + id

      _this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          _this.is_loading = true
          axios.delete(delete_api_url)
              .then(response => {
                _this.list.data.splice(index, 1)
                _this.$toaster.success(response.data.message)
                _this.is_loading = false
              })
              .catch(error => {
                _this.is_loading = false
                console.log(error)
                _this.$swal.fire(
                    "Failed!",
                    "failed to delete.",
                    "error"
                )
              })
              .finally(() => {
                _this.is_loading = false
              });
        }
      });
    },
    exportFile: function () {
      this.is_loading = true
      axios.get("/ew-trx-activity-types-export", {responseType: "blob"})
          .then(response => {
            fileDownload(response.data, "trx_activity_types.xlsx")
          })
          .catch((error) => {
            console.log('error ' + error)
          })
          .finally(() => {
            this.is_loading = false
            Notification.success({
              title: 'Export Completed',
              message: 'Export operation completed successfully',
              type: 'success'
            })
          });
    },
    selectedRowAll: function () {
      let isSelectedAll = this.is_selected_all = !this.is_selected_all
      if (isSelectedAll) {
        var items = []
        this.list.data.forEach(function (item) {
          items.push(item.id)
        })
        this.selected_row = items
      } else {
        this.selected_row = []
      }
    },
    handleSelectedRows(command) {
      if (command === 'delete') {
        axios({
          method: 'delete',
          url: '/ew_trx_activity_types/delete-all',
          data: {'ids': this.selected_row},
          headers: {'Content-Type': 'application/json'},
        }).then(function (response) {
          Notification.success({title: 'Deleted Successfully', message: 'Data deleted successfully', type: 'success'})
          this.initialize()
        }).catch((errors) => {
          // eslint-disable-next-line no-undef
          if (!_.isEmpty(errors.response) && errors.response.status === 500) {
            this.$toaster.error(errors.response.data.message)
          }
        }).finally(() => {
          this.is_selected_all = false
          this.initialize()
        });
      }
    },
    getActivityTypes: function () {
      this.is_loading = true
      axios.get("/get-trx-activity-types")
          .then(response => {
            // console.log('response', response)
            this.activityTypes = response.data
          })
          .catch((error) => {
            console.log('error ' + error)
          })
          .finally(() => {
            this.is_loading = false
          });
    },
    showTrxActivityTypeLogs: function (id) {
      this.getTrxActivityTypeLogs(id).then(response => {
        this.trxActivityTypeLogs = response.data
        this.$bvModal.show('trxActivityTypeLogs')
      });
    },

    getTrxActivityTypeLogs: function (id) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        const api_url = '/getTrxActivityTypeLogs/' + id;
        axios.get(api_url)
            .then(response => {
              resolve(response)
            })
            .catch((error) => {
              console.log('error ' + error)
              reject(error)
            })
            .finally(() => {
            });
      })
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
